import StopSchedule from './container'

export default StopSchedule
